import { cn } from '@/lib/utils';
import { ComponentPropsWithoutRef, useCallback, useEffect, useState } from 'react';
import { ClassNameValue } from 'tailwind-merge';

interface IProps extends Omit<ComponentPropsWithoutRef<'div'>, 'className'> {
  onTabChange?: (active: number, tab: string) => void;
  tabs: string[];
  wrapperClassName?: ClassNameValue;
  defaultActive?: number;
  activeIndex?: number;
}
const activeClass =
  'relative after:content-normal after:absolute after:bottom-[-8px] after:w-[20px] after:h-[3px] after:absolute after:bg-themeColor after:left-[50%] after:translate-x-[-50%]';

export default (props: IProps) => {
  const { onTabChange, activeIndex, defaultActive, tabs, wrapperClassName, ...attr } = props;

  const [internalActive, setInternalActive] = useState(defaultActive);

  const activeTab = activeIndex ?? internalActive;

  useEffect(() => {
    if (defaultActive !== undefined && activeIndex === undefined) {
      setInternalActive(defaultActive);
    }
  }, [defaultActive, activeIndex]);

  const handleTabClick = useCallback(
    (index: number, tab: string) => {
      if (activeIndex === undefined) {
        setInternalActive(index);
      }
      onTabChange?.(index, tab);
    },
    [activeIndex, onTabChange],
  );

  const renderTabItem = (tab: string, index: number) => {
    const isActive = index === activeTab;

    return (
      <div
        key={index}
        className={cn('flex items-center gap-x-[3px] cursor-pointer', isActive && activeClass)}
        onClick={() => handleTabClick(index, tab)}
      >
        <span className={cn(isActive ? 'text-primaryTextColor' : 'text-secondaryTextColor')}>{tab}</span>
      </div>
    );
  };

  return (
    <div className={cn('flex gap-x-[10px] mb-[8px]', wrapperClassName)} {...attr}>
      {tabs.map(renderTabItem)}
    </div>
  );
};
